import { render } from "./PurchasePauseModal.vue?vue&type=template&id=f2082c32&ts=true&lang=pug"
import script from "./PurchasePauseModal.vue?vue&type=script&lang=ts"
export * from "./PurchasePauseModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__